import { render, staticRenderFns } from "./popup.vue?vue&type=template&id=d2159ee6&scoped=true&lang=pug&"
import script from "./popup.vue?vue&type=script&lang=js&"
export * from "./popup.vue?vue&type=script&lang=js&"
import style0 from "./popup.vue?vue&type=style&index=0&id=d2159ee6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2159ee6",
  null
  
)

export default component.exports